'use strict';

exports.__esModule = true;
exports.SEARCH_SOURCE_PHONE_LOOKUP = exports.SEARCH_SOURCE_NAME_LOOKUP = exports.SEARCH_SOURCE_ZONES = exports.SEARCH_SOURCE_ADDRESS_BOOK = exports.SEARCH_SOURCE_EXTERNAL = exports.getAddressLabel = exports.NO_RESULTS_VALUE = exports.ENTER_ADDRESS_MANUALLY_VALUE = exports.ENTER_ADDRESS_MANUALLY_LABEL = exports.FETCH_DEBOUNCE_TIME = undefined;

var _trim = require('lodash/trim');

var _trim2 = _interopRequireDefault(_trim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_DEBOUNCE_TIME = exports.FETCH_DEBOUNCE_TIME = 500;

var ENTER_ADDRESS_MANUALLY_LABEL = exports.ENTER_ADDRESS_MANUALLY_LABEL = 'Enter address manually';
var ENTER_ADDRESS_MANUALLY_VALUE = exports.ENTER_ADDRESS_MANUALLY_VALUE = 'enter-address-manually';

var NO_RESULTS_VALUE = exports.NO_RESULTS_VALUE = 'no-results';

var getAddressLabel = exports.getAddressLabel = function getAddressLabel(location) {
  if (!location || !location.address1) return '';

  var address1 = (0, _trim2.default)(location.address1);
  var address2 = (0, _trim2.default)(location.address2);
  var name = (0, _trim2.default)(location.name);
  var postcode = (0, _trim2.default)(location.postcode);

  return [!address1.includes(name) && name, address1, !address1.includes(address2) && address2, !address1.includes(postcode) && postcode].filter(Boolean).join(', ');
};

var SEARCH_SOURCE_EXTERNAL = exports.SEARCH_SOURCE_EXTERNAL = 'EXTERNAL';
var SEARCH_SOURCE_ADDRESS_BOOK = exports.SEARCH_SOURCE_ADDRESS_BOOK = 'ADDRESS_BOOK';
var SEARCH_SOURCE_ZONES = exports.SEARCH_SOURCE_ZONES = 'ZONES';
var SEARCH_SOURCE_NAME_LOOKUP = exports.SEARCH_SOURCE_NAME_LOOKUP = 'NAME_LOOKUP';
var SEARCH_SOURCE_PHONE_LOOKUP = exports.SEARCH_SOURCE_PHONE_LOOKUP = 'PHONE_LOOKUP';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/components/qu-address/utils.js
// module id = 1031
// module chunks = 0